import { create } from 'zustand';
import { adminAuthService, type AdminLoginRequest } from '../services/adminAuthService';
import { getStoredAdminUser, type AdminUser } from '../constants/adminSession';

interface AdminAuthState {
  admin: AdminUser | null;
  isLoading: boolean;
  error: string | null;
  login: (credentials: AdminLoginRequest) => Promise<void>;
  logout: () => Promise<void>;
  clearError: () => void;
  initialize: () => void;
}

export const useAdminAuthStore = create<AdminAuthState>((set) => ({
  admin: null,
  isLoading: false,
  error: null,

  login: async (credentials) => {
    set({ isLoading: true, error: null });
    try {
      const response = await adminAuthService.login(credentials);
      set({ admin: response.user, isLoading: false, error: null });
    } catch (error) {
      set({
        isLoading: false,
        error: error instanceof Error ? error.message : '登录失败',
      });
      throw error;
    }
  },

  logout: async () => {
    set({ isLoading: true });
    try {
      await adminAuthService.logout();
    } finally {
      set({ admin: null, isLoading: false, error: null });
    }
  },

  clearError: () => set({ error: null }),

  initialize: () => {
    const stored = getStoredAdminUser();
    if (stored && adminAuthService.isAuthenticated()) {
      set({ admin: stored });
    }
  },
}));
